"use client"

import Script from "next/script"
import { usePathname } from "next/navigation"
import { useEffect } from "react"

const GA_ID = "G-06YVXBX0MW"
const PLAUSIBLE_SRC = "https://plausible.magicface.co/js/pa-WjXwQ0rrBCknwYWQ3YJnB.js"

export default function AnalyticsScripts() {
    const pathname = usePathname()
    const isManagerRoute = pathname?.startsWith("/manager")
    const isProd = process.env.NODE_ENV === "production"

    useEffect(() => {
        if (!isProd) return

        if (isManagerRoute) {
            // Disable GA (prevents sending hits even if script was loaded earlier)
            window[`ga-disable-${GA_ID}`] = true

            // Best-effort: remove injected scripts/initializers if user navigated into /manager
            document.getElementById("google-analytics")?.remove()
            document.getElementById("plausible-init")?.remove()

            document
                .querySelectorAll(`script[src^="https://www.googletagmanager.com/gtag/js"]`)
                .forEach((el) => el.remove())
            document.querySelectorAll(`script[src="${PLAUSIBLE_SRC}"]`).forEach((el) => el.remove())

            // Best-effort: noop plausible calls
            window.plausible = function () { }
            window.plausible.q = []
        } else {
            // Re-enable GA when leaving /manager
            window[`ga-disable-${GA_ID}`] = false
        }
    }, [isManagerRoute, isProd])

    if (!isProd) return null
    if (isManagerRoute) return null

    return (
        <>
            {/* Google Analytics */}
            <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`} strategy="afterInteractive" />
            <Script id="google-analytics" strategy="afterInteractive">
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${GA_ID}');
                `}
            </Script>

            {/* Plausible */}
            <Script src={PLAUSIBLE_SRC} strategy="afterInteractive"></Script>
            <Script id="plausible-init" strategy="afterInteractive">
                {`
                    window.plausible=window.plausible||function(){(window.plausible.q=window.plausible.q||[]).push(arguments)},window.plausible.init=window.plausible.init||function(i){window.plausible.o=i||{}};
                    window.plausible.init()
                `}
            </Script>
        </>
    )
}

